import { render, staticRenderFns } from "./chargesDetailsModal.vue?vue&type=template&id=6b7aaf68&scoped=true"
import script from "./chargesDetailsModal.vue?vue&type=script&lang=js"
export * from "./chargesDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./chargesDetailsModal.vue?vue&type=style&index=0&id=6b7aaf68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7aaf68",
  null
  
)

export default component.exports